module.exports = __webpack_public_path__ + "static/media/img118_R.99461417.jpg";